<template>
  <div>
    <v-btn small icon @click="handleShowFormClick">
      <v-icon small>fa-trash</v-icon>
    </v-btn>

    <v-dialog v-model="showModal" max-width="800">
      <v-card v-if="showModal">
        <v-card-title class="headline">Service log deletion?</v-card-title>
        <v-card-text>
          <v-text-field
            label="Comment"
            v-model="comment"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleHideForm">Cancel</v-btn>
          <v-btn @click="handleSendForm">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import {notificationService} from '../../../application'

    export default {
        name: 'delete-case-service-log-form',
        components: {},
        props: {
            id: {
                type: Number,
                required: true
            },
            caseId: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                showModal: false,
                comment: ''
            }
        },
        computed: {},
        mounted() {
        },
        watch: {
            showModal() {
                if (!this.showModal) {
                    this.resetForm()
                }
            }
        },
        methods: {
            ...mapActions({
                deleteCaseServiceLog: 'deleteCaseServiceLog'
            }),
            handleShowFormClick() {
                this.showModal = true
            },
            handleSendForm() {
                this
                    .deleteCaseServiceLog({
                        caseId: this.caseId,
                        id: this.id,
                        comment: this.comment
                    })
                    .then(() => {
                        this.showModal = false
                    })
                    .catch(e => {
                        notificationService.error('Operation failed');
                        throw e
                    })
            },
            resetForm() {
                this.comment = 'null'
            },
            handleHideForm() {
                this.resetForm();
                this.showModal = false
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Sales/case/DeleteCaseServiceLogForm.vue